import type { IconData } from '@stacksjs/iconify-core'

export const check: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5.486 9.73a1 1 0 0 1-.707-.292L.537 5.195A1 1 0 1 1 1.95 3.78l3.535 3.535L11.85.952a1 1 0 0 1 1.415 1.414L6.193 9.438a1 1 0 0 1-.707.292\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default check
